import request from '@/utils/request'
import qs from 'qs'


/**
 * 试卷列表
 * @param query
 */
export function fetchList(query) {
    return request({
        url: '/api/paper/list',
        method: 'post',
        data: query || {}
    })
}


/**
 * 删除试卷
 * @param param
 */
export function remove(param) {
    return request({
        url: '/api/paper/delete/' + param,
        method: 'get'
    })
}

/**
 * 获取单个试卷信息
 * @param param
 */
export function get(param) {
    return request({
        url: '/api/paper/get/' + param,
        method: 'get'
    })
}

/**
 * 保存试卷
 * @param param
 */
export function save(param) {
    return request({
        url: '/api/paper/save',
        method: 'post',
        data: param
    })
}

/**
 * 修改试卷
 * @param param
 */
export function update(param) {
    return request({
        url: '/api/paper/update',
        method: 'post',
        data: param
    })
}


